export const UserVerificationStatus = {
  VERIFIED: 'VERIFIED',
  NOT_VERIFIED: 'NOT_VERIFIED',
  IN_PROGRESS: 'IN_PROGRESS',
  REJECTED: 'REJECTED',
  POSTED: 'POSTED',
};
